import { render, staticRenderFns } from "./HandleTemplateSidebar.vue?vue&type=template&id=09ee4789&scoped=true&"
import script from "./HandleTemplateSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleTemplateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleTemplateSidebar.vue?vue&type=style&index=0&id=09ee4789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee4789",
  null
  
)

export default component.exports